<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <a-drawer v-if="drawerVisible" title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">

            <br>
            
            <div v-if="type == 'a'">
                <base-input label="Select Accounts on the List">
                    <br/>
                    <a-select v-model="accountIds" mode="multiple" showSearch placeholder="Search Account" :filterOption="false" :defaultActiveFirstOption="false" style="width: 100%" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in accountOptions" :key="option.id" :value="option.id">{{option.account_name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-if="type == 's'">
                <h6 class="heading-small text-muted pb-3">Select sites where updated version will be deployed</h6>
                <ul class="list-group list-group-flush" style="width: 100%">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                        <div class="row">
                            <div class="col-md-6">
                                SITE LIST
                            </div>
                            <div class="col-md-6">
                                <!-- @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 12" -->
                                <a-checkbox class="float-right" @change="onCheckAllUpdateSiteList" :checked="siteIds.length == sites.length" />
                            </div>
                         </div>
                    </li>

                    <li class="list-group-item" style="font-size: 14px" v-for="(site, index) in sites" :key=index>
                         <div class="row">
                             <div class="col-md-6">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{site.name}}
                            </div>
                            <div class="col-md-6">
                                <a-checkbox data-id="system_module.name" @change="onCheckUpdateSiteList(site.id)" :checked="siteIds.includes(site.id)" class="float-right"/>
                            </div>
                         </div>
                    </li>
                </ul>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                    <button class="btn btn-success" @click="updateSelectedSite">Save</button>
                </div>
            </div>

            <div v-if="type == 't'">
                <h6 class="heading-small text-muted pb-3">Select terminals where updated version will be deployed</h6>
                <ul class="list-group list-group-flush" style="width: 100%">
                    <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                        <div class="row">
                            <div class="col-md-6">
                                TERMINAL LIST
                            </div>
                            <div class="col-md-6">
                                <!-- @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 12" -->
                                <a-checkbox class="float-right" @change="onCheckAllUpdateTerminalList()" :checked="terminalIds.length == terminals.length" />
                            </div>
                         </div>
                    </li>

                    <li class="list-group-item" style="font-size: 14px" v-for="(terminal, index) in terminals" :key=index>
                         <div class="row">
                             <div class="col-md-6">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{terminal.name}}
                            </div>
                            <div class="col-md-6">
                                <a-checkbox data-id="system_module.name" @change="onCheckUpdateTerminalList(terminal.id)" :checked="terminalIds.includes(terminal.id)" class="float-right"/>
                            </div>
                         </div>
                    </li>
                </ul>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                    <button class="btn btn-success" @click="updateSelectedTerminal()">Save</button>
                </div>
            </div>

        </a-drawer>
        <div class="container-fluid mt--7">
            <div class="card mb-3">
                <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
                    <div class="col-md-12" style="height: 100vh;">
                        <a-tabs v-model:activeKey="activeKey" @change="createPosUpdate">
                            <a-tab-pane tab="POS Version Dashboard" key="1">
                                <div class="ml-3 mt-3 mr-3">
                                        <pos-release @changePosRelease="changePosRelease($event)" />
                                </div>  
                            </a-tab-pane>
                            <a-tab-pane tab="POS Release" key="2">
                                <a-spin :spinning="spinning" :tip="spinning_tip">
                                <div class="ml-3 mt-3 mr-3">
                                    <!-- {{accounts}} -->
                                    <div v-if="posRelease != null">
                                        <a-card title="Upload New POS Version" size="small" style="width: 100%">
                                            <a slot="extra" href="#">
                                                <button v-if="pos_update_id == 0 || view_mode == false" class="float-right btn btn-sm btn-success mr-2" @click="updateConfig"> <span class="fa fa-save" /> Save POS Release </button>
                                                <button v-if="pos_update_id > 0" class="float-right btn btn-sm mr-2" @click="activeKey = '1'; createPosUpdate();"> <span class="fa fa-arrow-left" /> Back </button>
                                            </a>
                                            
                                            <div class="row align-items-center">
                                            <div class="col-md-12">
                                                <base-alert v-if="errors.length" type="danger">
                                                    <b>You have the following error(s):</b>
                                                    <li v-for="error in errors" :key="error">{{ error }}</li>
                                                </base-alert>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="col-md-12">
                                                    <base-input label="Version:"> <a-tag color="green" v-if="latestVersion != ''">Latest: {{latestVersion}}</a-tag>
                                                        <a-input v-model='inputVersion' :disabled="view_mode" @blur="checkVersion" type='text' label="Version:" input-classes="form-control"/>
                                                    </base-input>
                                                </div>
                                                <div class="col-md-12">
                                                    <base-input label="Type:">
                                                        <a-select v-model="inputType" :disabled="view_mode" showSearch placeholder="Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                            <a-select-option v-for="option in releaseTypes" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
                                                </div>
                                                <div class="col-md-12">
                                                    <base-input label="Status:">
                                                        <a-select v-model="inputStatus" :disabled="view_mode" showSearch placeholder="Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                            <a-select-option v-for="option in releaseStatuses" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                                        </a-select>
                                                    </base-input>
                                                </div>
                                                <div class="col-md-12">
                                                    <base-input alternative="" label="Deployed At:">
                                                        <a-date-picker v-model="inputDeployedAt" :disabled="view_mode" format="MM-DD-YYYY" :disabled-date="disabledDate" placeholder="Deployed At" style="width:100%"/>
                                                    </base-input>
                                                </div>
                                                <div class="col-md-12">
                                                    <base-input alternative="" label="Applies For:"><br>
                                                        <a-switch :disabled="view_mode" class="float-left" checked-children="For All Accounts" un-checked-children="For Selected Accounts" v-model="accountFilter"/>
                                                    </base-input>
                                                </div>
                                            </div>
                                            <div class="col-md-3" >
                                                <a-spin :spinning="spinning_upload" tip="Uploading to S3...">
                                                    <div class="col-md-12" style="height: 100%">
                                                        <a-upload-dragger
                                                            :disabled="view_mode"
                                                            accept=".zip"
                                                            :file-list="posUpdate"
                                                            @change="handleposUpdate"
                                                            :remove="handleRemoveposUpdate"
                                                            :before-upload="beforeUploadposUpdate"
                                                            >
                                                                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                                                                <p class="ant-upload-text">Click or drag file to this area to upload your pos update file</p>
                                                                <p class="ant-upload-hint">Supports single upload of zip file (.zip)</p>
                                                        </a-upload-dragger>
                                                        
                                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <a-upload
                                                accept=".pdf"
                                                :file-list="releaseNotesPdfFile"
                                                @change="handleChangeReleaseNotes"
                                                :remove="handleRemoveReleaseNotes"
                                                :before-upload="beforeUploadReleaseNotes"
                                                :disabled="view_mode"
                                            >
                                                <a-button :disabled="view_mode"> <a-icon type="upload" /> Click to Upload Release Notes (.pdf)</a-button>
                                            </a-upload>
                                            <br/><br/>
                                            <a v-if="this.pos_update_id > 0" :href="posSourcePath" target="_blank" rel="noopener"><i class="fa fa-archive"></i> POS File</a>
                                            <br/>
                                            <a v-if="this.pos_update_id > 0" :href="posReleaseNotesPath" target="_blank" rel="noopener"><i class="fa fa-file-pdf"></i> Release Note</a>
                                        </div>
                                                    </div>
                                                </a-spin>
                                            </div>
                                            </div>
                                        </a-card>
                                    </div>

                           
                            <br>
                            
                            <div v-if="accountFilter == false">
                                <div class="row no-gutters">
                                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                                        <div class="list-group list-group-flush">
                                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                <div class="row">
                                                    <div class="col-md-6">Accounts</div>
                                                    <div class="col-md-6 float-right">
                                                         <base-button :disabled="view_mode" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('a')"><span class="fa fa-plus" /></base-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="accounts.length > 0">
                                                <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(account, index) in accounts" :key="index" :class="[{selected2: selectedAccount == account.id}]">
                                                    <div class="row" @click="setAccount(account)">
                                                       <div class="col-md-8">{{account.account_name}}</div>
                                                       <div class="col-md-4">
                                                          <span class="ni ni-bold-right float-right" style="padding-bottom: 5px; padding-top: 3px;"/>
                                                          <a v-if="!view_mode" href="#" class="text-danger float-right mr-2" title="Remove account" @click.prevent.stop="removeAccount(account)"><span class="fa fa-times" /></a>
                                                       </div>
                                                    </div>
                                                 </div>  
                                            </div>
                                            <div v-else>
                                               <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                   <span slot="description"> Please add accounts on the list. </span>
                                               </a-empty>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                                        <div class="list-group list-group-flush">
                                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                <div class="row">
                                                    <div class="col-md-6">Site List</div>
                                                    <!-- <div class="col-md-6 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addMenu', selectedMenu, 0)">+ Add Menu</base-button></div> -->
                                                    <div v-if="selectedAccount > 0" class="col-md-6 float-right">
                                                         <base-button :disabled="view_mode" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('s')"><span class="fa fa-plus" /></base-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="selectedAccount > 0" >
                                                <div v-if="sitesDisplay.length > 0 ">
                                                    <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(site, index) in sitesDisplay" :key="index" :class="[{selected2: selectedSite == site.id}]">
                                                         <!-- @click="setMainMenu(index)" -->
                                                         <div v-if="selectedAccount > 0" class="row" @click="setSite(site)">
                                                            <div class="col-md-8">{{site.name}}</div>
                                                            <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                         </div>
                                                    </div> 
                                                </div> 
                                                <div v-else>
                                                   <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                       <span slot="description"> All sites are selected by default for account <b>{{activeAccount.account_name}}</b> </span>
                                                   </a-empty>
                                                </div>
                                            </div>
                                            <div v-else>
                                               <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                   <span slot="description"> Please select an account.</span>
                                               </a-empty>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="list-group list-group-flush mr-3">
                                            <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                                <div class="row">
                                                    <div class="col-md-6">Terminal List</div>
                                                    <div v-if="selectedSite > 0" class="col-md-6 float-right">
                                                         <base-button :disabled="view_mode" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('t')"><span class="fa fa-plus" /></base-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="selectedSite > 0" >
                                            <div v-if="terminalsDisplay.length > 0">
                                                    <div class="list-group-item mr-3" style="font-size: 14px; border-radius: 0px;" v-for="(terminal, index) in terminalsDisplay" :key="index">
                                                         <!-- @click="setMainMenu(index)" -->
                                                         <div v-if="selectedSite > 0" class="row">
                                                            <div class="col-md-12">{{terminal.name}}</div>
                                                            <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                                                         </div>
                                                    </div> 
                                                </div> 
                                            <div v-else>
                                               <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                   <span slot="description"> All terminals are selected by default for site <b>{{activeSite.name}}</b> </span>
                                               </a-empty>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                                <span slot="description"> Please select a site. </span>
                                            </a-empty>
                                        </div>
                                    </div>
                                </div>
                            </div>

                                </div>
                                </a-spin>
                            </a-tab-pane>
                        </a-tabs>
                        <br><br>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js';
import PosRelease from '../Admin/PosRelease.vue'
import { mapState, mapActions } from 'vuex'
import { uploadToS3Presigned } from '../../utilities';
import moment from 'moment';
var component_x;

export default {
    components: {
        PosRelease
    },
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    data() { 
        return {
            spinning_tip: '',
            view_mode: false,
            pos_update_id: 0,
            activeKey: '1',
            latestVersion: "",
            errors: [],
            accountFilter: true,
            posRelease: {},
            branchFilter: "AB",
            accountOptions: [],
            fetching: false,
            accountIds: [],
            terminalIds: [],
            accountColumns: [
                {
                  title: 'Account Name',
                  dataIndex: 'account_name',
                  scopedSlots: { customRender: 'name' },
                },
                {
                  title: 'Site List',
                  dataIndex: 'operation',
                  scopedSlots: { customRender: 'operation' },
                }
            ],
            activeAccount: null,
            selectedAccount: 0,
            activeSite: null,
            selectedSite: 0,
            sites: [],
            terminals: [],
            accounts: [],
            siteIds: [],
            sitesDisplay: [],
            terminalIds: [],
            terminalsDisplay: [],
            drawerVisible: false,
            type: null,
            versionDeployed: false,
            posUpdate: [],
            posWaveletTxtList: [],
            posWaveletJson: null,
            posWaveletPrice: null,
            posWaveletId: null,
            posWaveletTextFiles: [],
            posFile1: null,
            posFile2: null,
            posSourcePath: null,
            posReleaseNotesPath: null,
            spinning: false,
            spinning_upload: false,
            releaseTypes : [
                {key: 'H', value: 'Hotfix'},
                {key: 'S', value: 'Scheduled'}
            ],
            releaseStatuses : [
                // {key: 'D', value: 'Deployed'},
                {key: 'F', value: 'For Deployment'},
                {key: 'P', value: 'Pending'}
            ],
            inputOs: 'W',
            inputVersion: '',
            inputType: '',
            inputStatus: 'P',
            inputDeployedAt: moment().endOf('day'),
            releaseNotesPdfFile: [],
        }
    },
    watch: {
        accountIds: function(){
            // Rebuild the accounts list from the selected ids while preserving
            // any existing account config (sites/terminals) already loaded, so
            // adding a new account appends instead of overriding the rest.
            var merged = []
            this.accountIds.forEach(id => {
                var existing = this.accounts.find(a => a.id == id)
                if(existing){
                    merged.push(existing)
                } else {
                    var option = this.accountOptions.find(o => o.id == id)
                    if(option) merged.push({ id: option.id, account_name: option.account_name, sites: [] })
                }
            })
            this.accounts = merged
        },
        accountFilter: function(){
            if(this.accountFilter == true){
                this.accounts = []
                this.accountIds = []
                this.siteIds = []
                this.terminalIds = []
                this.selectedSite = 0
                this.selectedAccount = 0
                this.activeAccount = 0
                this.activeSite = 0
            }

        }
    },
    methods: {
        createPosUpdate(){
            this.view_mode = false
            this.inputOs = 'W'
            this.inputVersion = ''
            this.inputType = ''
            this.inputStatus = ''
            this.inputDeployedAt = ''
            this.posSourcePath = ''
            this.posReleaseNotesPath = ''
            this.pos_update_id = 0
            this.posRelease.status = ''
            this.posSourcePath = null
            this.posReleaseNotesPath = null
            this.accounts = []
            this.accountFilter = true
        },
        async changePosRelease(e) {
            this.spinning = true
            this.spinning_tip = "Fetching POS Update Data..."
            var i = e.split('|')
            this.activeKey = '2';
            this.view_mode = (i[1] == 'V') ? true : false
            this.pos_update_id = i[0]
            this.errors = [];
            //Get Pos Update Details
            var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_pos_version?id='+i[0] , null, )
            this.posRelease = posRelease.success
            if(this.posRelease.release_config != null){
                this.accounts = JSON.parse(this.posRelease.release_config)
                // Seed the multi-select so existing accounts stay selected and
                // adding a new account appends instead of overriding.
                this.accountIds = this.accounts.map(x => x.id)
                this.accountOptions = this.accounts.map(x => ({ id: x.id, account_name: x.account_name }))
                this.accountFilter = false
                // Auto-expand the first account so its sites (and first site's
                // terminals) show without needing an extra click. Applies to
                // both view and edit modes.
                this.$nextTick(async () => {
                    if(this.accounts.length > 0){
                        await this.setAccount(this.accounts[0])
                        if(this.sitesDisplay.length > 0){
                            await this.setSite(this.sitesDisplay[0])
                        }
                    }
                })
            } else {
                this.accountFilter = true
            }
                
            this.inputOs = this.posRelease.os
            this.inputVersion = this.posRelease.version
            this.inputType = this.posRelease.update_type
            this.inputStatus = this.posRelease.status
            this.inputDeployedAt = this.posRelease.deployed_at
            this.posSourcePath = this.extractPath(this.posRelease.path)
            this.posReleaseNotesPath = this.extractPath(this.posRelease.release_notes)

            if(this.posRelease.status == 'D')
                this.versionDeployed = true
            else
                this.versionDeployed = false
            this.spinning = false
        },
        handleRemoveReleaseNotes(file) {
            const index = this.releaseNotesPdfFile.indexOf(file);
            const newFileList = this.releaseNotesPdfFile.slice();
            newFileList.splice(index, 1);
            this.releaseNotesPdfFile = newFileList;
        },
        beforeUploadReleaseNotes(file) {
            this.releaseNotesPdfFile = [...this.releaseNotesPdfFile, file];
            return false;
        },
        async handleChangeReleaseNotes(file){
            var latestUpload = this.releaseNotesPdfFile[this.releaseNotesPdfFile.length - 1]
            if (latestUpload == undefined) return
            // Validate: release notes must be a .pdf file.
            var fileExtension = latestUpload.name.split(".").pop().toLowerCase()
            if(fileExtension != "pdf"){
                this.$notification['error']({
                    message: 'Unsupported file type',
                    description: "Upload .pdf files only."
                });
                this.handleRemoveReleaseNotes(file)
                return
            }
            if(this.releaseNotesPdfFile.length > 1)
                this.handleRemoveReleaseNotes(this.releaseNotesPdfFile[0])

            // Upload the original File as-is (no rename/reconstruction) straight
            // to S3 via a presigned URL. This bypasses the API Gateway 10MB limit
            // and avoids the File-rebuild bug that uploaded "[object Object]".
            const sourceFile = latestUpload.originFileObj || latestUpload
            var uploadResult = await uploadToS3Presigned(sourceFile, 'pos_release_notes');
            if(uploadResult && uploadResult['error']){
                this.$notification['error']({
                    message: 'S3 uploader error',
                    description: uploadResult['error'].code + " : " + uploadResult['error'].message
                });
                this.handleRemoveReleaseNotes(file)
            }  else {
                return this.posReleaseNotesPath = this.extractPath(uploadResult)
            }
        },
        // Normalize an S3 uploader result (or a previously stored value) to the
        // plain string path. Guards against storing "[object Object]".
        extractPath(value){
            if(value == null) return null
            if(typeof value === 'string') return value
            if(typeof value === 'object') return value.path || null
            return null
        },
        async handleposUpdate(file){
            this.spinning_upload = true
            var latestUpload = this.posUpdate[this.posUpdate.length - 1]
            if (latestUpload == undefined) { this.spinning_upload = false; return }
            // Validate: POS update must be a .zip file.
            var fileExtension = latestUpload.name.split(".").pop().toLowerCase()
            if(fileExtension != "zip"){
                this.$notification['error']({
                    message: 'Unsupported file type',
                    description: "Upload .zip files only."
                });
                this.handleRemoveposUpdate(file)
                this.spinning_upload = false
                return
            }
            if(this.posUpdate.length > 1)
                this.handleRemoveposUpdate(this.posUpdate[0])

            // Upload the original File as-is (no rename/reconstruction) straight
            // to S3 via a presigned URL. The POS zip is too large for the API
            // Gateway uploader (10MB limit), so this PUTs directly to S3.
            const sourceFile = latestUpload.originFileObj || latestUpload
            var uploadResult = await uploadToS3Presigned(sourceFile, 'pos_updates');
            if(uploadResult && uploadResult['error']){
                this.$notification['error']({
                    message: 'S3 uploader error',
                    description: uploadResult['error'].code + " : " + uploadResult['error'].message
                });
                this.handleRemoveposUpdate(file)
                this.spinning_upload = false
            }  else {
                this.spinning_upload = false
                return this.posSourcePath = this.extractPath(uploadResult)
            }
            this.spinning_upload = false
        },
        disabledDate(current) {
            return current < moment(this.inputDeployedAt, "YYYY-MM-DD").add(0, 'days');
        },
        handleRemoveposUpdate(file) {
                const index = this.posUpdate.indexOf(file);
                const newFileList = this.posUpdate.slice();
                newFileList.splice(index, 1);
                this.posUpdate = newFileList;
        },
        beforeUploadposUpdate(file) {
            this.posUpdate = [...this.posUpdate, file];
            return false;
        },
        updateSelectedSite(){
            // Preserve terminals already configured for sites that stay selected.
            var previousSites = this.activeAccount.sites || []
            var rebuiltSites = []
            var rebuiltDisplay = []
            this.sites.map(x => {
                if(this.siteIds.includes(x.id)){
                    var existing = previousSites.find(s => s.id == x.id)
                    var siteEntry = { id: x.id, name: x.name, terminals: (existing && existing.terminals) ? existing.terminals : [] }
                    rebuiltSites.push(siteEntry)
                    // Keep sitesDisplay pointing at the SAME object stored in
                    // activeAccount.sites so terminal edits stay in sync.
                    rebuiltDisplay.push(siteEntry)
                }
            })
            this.activeAccount.sites = rebuiltSites
            this.sitesDisplay = rebuiltDisplay
            this.onClose()
        },
        onCheckUpdateSiteList(siteId){
            if(this.siteIds.includes(siteId)){
                var index = this.siteIds.indexOf(siteId);
                this.siteIds.splice(index, 1)
            }
            else{
                this.siteIds.push(siteId)
            }
        },
        onCheckAllUpdateSiteList(){
            if(this.siteIds.length == this.sites.length){
                this.siteIds = []
            } else {
                this.siteIds = []
                this.sites.map(x => {
                    this.siteIds.push(x.id)
                })
            }
        },
        updateSelectedTerminal(){
            this.terminalsDisplay = []
            this.activeSite.terminals = []
            this.terminals.map(x => {
                if(this.terminalIds.includes(x.id)){
                    this.terminalsDisplay.push(x)
                    this.activeSite.terminals.push({id: x.id, name: x.name})
                }
            })
             this.activeAccount.sites.map( y => {
                 if(y.id == this.selectedSite){
                     y.terminals = this.activeSite.terminals
                 }
             })
            this.onClose()
        },
        onCheckUpdateTerminalList(terminalId){
            if(this.terminalIds.includes(terminalId)){
                var index = this.terminalIds.indexOf(terminalId);
                this.terminalIds.splice(index, 1)
            }
            else{
                this.terminalIds.push(terminalId)
            }
        },
        onCheckAllUpdateTerminalList(){
            if(this.terminalIds.length == this.terminals.length){
                this.terminalIds = []
            } else {
                this.terminalIds = []
                this.terminals.map(x => {
                    this.terminalIds.push(x.id)
                })
            }
        },
        onClose(){
            this.drawerVisible = false
        },
        openDrawer(type){
           this.type = type
           this.drawerVisible = true
        },
        removeAccount(account){
            // Remove from the selected ids; the accountIds watcher rebuilds
            // the accounts list (preserving the config of those that remain).
            var index = this.accountIds.indexOf(account.id)
            if(index !== -1) this.accountIds.splice(index, 1)
            // If the removed account was the active one, clear the site/terminal panels.
            if(this.selectedAccount == account.id){
                this.selectedAccount = 0
                this.selectedSite = 0
                this.activeAccount = 0
                this.activeSite = 0
                this.sites = []
                this.sitesDisplay = []
                this.siteIds = []
                this.terminals = []
                this.terminalsDisplay = []
                this.terminalIds = []
            }
        },
        async setAccount(account){
            this.activeAccount = account
            this.selectedAccount = account.id;
            this.sitesDisplay = []
            this.siteIds = []
            this.terminalsDisplay = []
            this.terminalIds = []
            var sites = await HTTPRequest.getRequest(this.endPoint + "/sites?mode=admin&account_id=" + account.id , null, null)   
            this.sites = sites.data
            if(this.activeAccount.sites != undefined && this.activeAccount.sites != null){
                 this.activeAccount.sites.forEach( x => {
                    if(!this.siteIds.includes(x.id)){
                        this.siteIds.push(x.id)
                        this.sitesDisplay.push(x)
                    }
                })
            }
        },
        async setSite(site){
            this.activeSite = site;
            this.selectedSite = site.id;
            this.terminalsDisplay = []
            this.terminalIds = []
            var terminals = await HTTPRequest.getRequest(this.endPoint + "/terminals?mode=admin&site_id=" + site.id + "&account_id=" + this.selectedAccount , null, null)   
            this.terminals = terminals.data
            if(this.activeSite.terminals != undefined && this.activeSite.terminals != null){
                 this.activeSite.terminals.forEach( x => {
                    if(!this.terminalIds.includes(x.id)){
                        this.terminalIds.push(x.id)
                        this.terminalsDisplay.push(x)
                    }
                })
            }
        },
        filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        checkVersion(){
            if (this.latestVersion != '' || this.latestVersion != null) {
                if (this.latestVersion.split(' | ')[0].replace(".", "") >= this.inputVersion.replace(".", "")){
                    this.inputVersion = ""
                    this.errors.push('The version must be higher than the current version.');
                    this.errors = this._.compact(this.errors);
                    return this.errors.length;
                }
            }  
        },
        async getLatestVersion(){
            var version = await HTTPRequest.getRequest(this.endPoint + "/pos_releases/get_latest_version?os=W" , null, null)   
            if (version != null)
                this.latestVersion = version['version'] + ' | ' + version['status']
            else
                this.latestVersion = ''
        },
        async handleSearch(value){
            this.fetching = true;
            var accounts = await HTTPRequest.getRequest(this.endPoint + "/accounts/get_valid_accounts?name=" + value , null, null)
            // Keep already-selected accounts in the options so their labels
            // still render (and stay selected) after a new search.
            var selected = this.accounts.map(a => ({ id: a.id, account_name: a.account_name }))
            var results = accounts || []
            var mergedOptions = selected.slice()
            results.forEach(r => {
                if(!mergedOptions.some(o => o.id == r.id)) mergedOptions.push(r)
            })
            this.accountOptions = mergedOptions
            this.fetching = false;
        },
        async getLatest(){
            var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/get_latest' , null, )
            if(posRelease.warning){
                this.$notification['warning']({
                  message: 'Version Conflict',
                  description: "Current version is not yet marked as deployed. "
                });
                return;
            }
            if(posRelease.info){
                this.$notification['info']({
                  message: 'Version Okay',
                  description: "Current version is up to date."
                });
                return;
            }
            if(posRelease.success){
                this.$notification['success']({
                  message: 'Version Updated',
                  description: "Please configure the new version for release."
                });
                this.posRelease = posRelease.success;
                if(this.posRelease.release_config == null)
                    this.accounts = []
                else
                    this.accounts = this.posRelease.release_config
                this.accountFilter = true
                this.versionDeployed = false
                // this.posRelease = posRelease.success;
                return;
            }
        },
        async updateConfig(){
            if (!this.validateForm()) {
                this.spinning = true;
                this.spinning_tip = "Saving POS Release..."
                var release_configs = []
                release_configs.push({
                    account_id: null,
                    site_id: null,
                    terminal_id: null
                })
                var releaseConfig = (this.accountFilter == true) ? null : JSON.stringify(this.accounts)
                var release_details = []
                release_details.push({
                    path: this.extractPath(this.posSourcePath),
                    release_notes: this.extractPath(this.posReleaseNotesPath),
                    os: this.inputOs,
                    version: this.inputVersion,
                    update_type: this.inputType,
                    status: this.inputStatus,
                    deployed_at: this.inputDeployedAt,
                })
                var posReleasePayload = { release_details: release_details, release_config: releaseConfig, for_all: release_configs }
                if(this.posRelease.id == undefined)
                    var posRelease = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/new_pos_version?id=' + ((this.posRelease.id == undefined) ? 0 : this.posRelease.id) , null, posReleasePayload)
                else
                    var posRelease = await HTTPRequest.postRequest(this.endPoint + 'pos_releases/update_pos_update?id=' + ((this.posRelease.id == undefined) ? 0 : this.posRelease.id) , null, posReleasePayload)
                // console.log(posRelease)
                if(posRelease.error == undefined){
                    this.$notification['success']({
                    message: 'Configuration Saved',
                    description: "Your release has been configured accordingly. "
                    });
                    this.posRelease  = posRelease
                } else {
                    this.$notification['error']({
                    message: 'Configuration Error',
                    description: posRelease.error
                    });
                }
                this.spinning = false;
            }
        },
        validateForm() {
            this.errors = [];
            if(!this.accountFilter)
                this.errors.push(ValidateField.isEmpty("Account", this.accounts));
            this.errors.push(ValidateField.isNull("POS File", this.posSourcePath)); 
            this.errors.push(ValidateField.isNull("POS Release Notes", this.posReleaseNotesPath));
            this.errors.push(ValidateField.required("Version", this.inputVersion));
            this.errors.push(ValidateField.required("Type", this.inputType));
            this.errors.push(ValidateField.required("Status", this.inputStatus));
            this.errors.push(ValidateField.required("Deployed At", this.inputDeployedAt));
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        async deploy(){
            var posReleasePayload = { pos_release: { status: 'D' }}
            var posRelease = await HTTPRequest.putRequest(this.endPoint + 'pos_releases/' + this.posRelease.id , null, posReleasePayload)
            // console.log(posRelease)
            if(posRelease.error == undefined){
                this.$notification['success']({
                  message: 'Release Marked as Deployed',
                  description: "Your version is ready for download for all accounts."
                });
            }
            this.getPosRelease()
        },
        async getPosRelease(){
             var posRelease = await HTTPRequest.getRequest(this.endPoint + 'pos_releases/' , null, )
            this.posRelease = posRelease.success
            if(this.posRelease.release_config != null){
                this.accounts = JSON.parse(this.posRelease.release_config)
                //this.accountFilter = false
            }
            if(this.posRelease.status == 'D')
                this.versionDeployed = true
        }
    },
    mounted: async function(){
        component_x = this;
       //await this.getPosRelease()
       await this.getLatestVersion();
    }
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>